module.exports = __webpack_public_path__ + "img/CentroOeste.20d0c3d7.png";